import { render } from "./patientnotes.vue?vue&type=template&id=1ae9d5dc"
import script from "./patientnotes.vue?vue&type=script&lang=js"
export * from "./patientnotes.vue?vue&type=script&lang=js"

import "./patientnotes.vue?vue&type=style&index=0&id=1ae9d5dc&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__